import React, { type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import FJUtil from '../../../util/FJUtil';

interface FJAnchorProps {
    zIndex?: number;
    isTopLayer?: boolean;
    useBody?: boolean;
    children?: ReactNode;
}

const FJAnchor: React.FC<FJAnchorProps> = ({ zIndex, isTopLayer, children }) => {
    let index: number | 'inherit' = 0;
    const isSafari = FJUtil.getBrowser() === 'Safari';

    if (zIndex) {
        index = zIndex;
    } else if (isTopLayer) {
        index = 999999;
    } else {
        index = isSafari ? 99 : 'inherit';
    }

    return createPortal(
        <div
            style={{
                position: isSafari ? 'fixed' : 'absolute',
                top: 0,
                left: 0,
                width: 0,
                height: 0,
                zIndex: index,
            }}
        >
            {children}
        </div>,
        document.body,
    );
};

export default FJAnchor;
